import moment from "moment";

const lastSyncedTimeDiff = (startTime: string) => {
    
    const diffInHours = moment().diff(startTime, "hours");
    if (diffInHours <= 24) {
        return 0;
    } else if (diffInHours > 24 && diffInHours <= (24*3)) {
        return 1;
    } else if (diffInHours > (24*3) && diffInHours <= (24*6)) {
        return 2;
    } else if (diffInHours > (24*6) ) {
        return 3;
    } 
};

export default lastSyncedTimeDiff;
